import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carCylinder";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
